export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Maria Silva',
      location: 'Blumenau - SC',
      event: 'Casamento',
      text: 'DJ Jean foi sensacional no nosso casamento! A iluminação estava perfeita e todos os convidados elogiaram a qualidade do som. Super profissional e pontual!',
    },
    {
      name: 'Carlos Rodrigues',
      location: 'Indaial - SC',
      event: 'Aniversário 50 anos',
      text: 'Contratei o DJ Jean para minha festa de 50 anos e foi um sucesso total! Música de qualidade, interação excelente com os convidados. Recomendo!',
    },
    {
      name: 'Ana Paula Oliveira',
      location: 'Timbó - SC',
      event: 'Debutante',
      text: 'A festa de 15 anos da minha filha ficou inesquecível! DJ Jean tocou todos os hits que pedimos e os efeitos especiais foram incríveis. Muito obrigada!',
    },
    {
      name: 'Roberto Santos',
      location: 'Gaspar - SC',
      event: 'Evento Corporativo',
      text: 'Excelente profissional! Contratamos para nossa confraternização de fim de ano e superou as expectativas. Som perfeito e muita animação!',
    },
    {
      name: 'Juliana Costa',
      location: 'Blumenau - SC',
      event: 'Casamento',
      text: 'DJ Jean foi fundamental para o sucesso do nosso casamento! Desde a cerimônia até a festa, tudo perfeito. Atendimento impecável desde o primeiro contato!',
    },
    {
      name: 'Pedro Müller',
      location: 'Indaial - SC',
      event: 'Aniversário',
      text: 'Festa incrível! DJ Jean soube ler muito bem o público e tocou exatamente o que todos queriam ouvir. Equipamentos de primeira qualidade!',
    },
    {
      name: 'Fernanda Becker',
      location: 'Timbó - SC',
      event: 'Formatura',
      text: 'Contratamos para nossa formatura e foi perfeito! DJ Jean é muito atencioso, profissional e tem um equipamento top. Super recomendo!',
    },
    {
      name: 'Marcos Zimmermann',
      location: 'Gaspar - SC',
      event: 'Inauguração',
      text: 'DJ Jean prestou um excelente serviço na inauguração da nossa loja. Som potente, locução profissional e muita qualidade. Parabéns pelo trabalho!',
    },
  ];

  return (
    <section id="depoimentos" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Depoimentos</h2>
          <p className="text-base md:text-lg text-gray-600">Veja o que nossos clientes dizem sobre nosso trabalho</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 p-4 rounded-xl shadow-lg">
              <div className="flex items-center mb-3">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-user-3-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 text-sm">{testimonial.name}</h4>
                  <p className="text-xs text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="mb-3">
                <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                  {testimonial.event}
                </span>
              </div>
              
              <p className="text-gray-700 italic text-xs">{testimonial.text}</p>
              
              <div className="flex text-yellow-400 mt-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}